<div class="product-related produto-slider-item" *ngIf="template == 'one'">
    <div class="produtos slider-itens" #slider>   
        <div class="slider-item item-servicos" *ngFor="let item of data"> 
            <produto-item [data]="item"></produto-item>    
        </div>    
    </div>   
    <div class="slide-navigate-item swiper-button-prev sw-btn" (click)="prev()">
        <div class="content">  
            <i class="material-icons">navigate_before</i>
        </div>
    </div>
    <div class="slide-navigate-item swiper-button-next sw-btn" (click)="next()">
        <div class="content"> 
            <i class="material-icons">navigate_next</i>
        </div>
    </div>
</div>
<div class="product-related produto-slider-item" *ngIf="template == 'two'"> 
    <h3 *ngIf="_titulo != ''">{{_titulo}}</h3>    
    <div class="produtos slider-itens" #slider>   
        <div class="slider-item item-servicos" *ngFor="let item of data"> 
            <produto-item-two [data]="item"></produto-item-two>     
        </div>     
    </div> 
    <div class="slide-navigate-item swiper-button-prev sw-btn" (click)="prev()">
        <div class="content">  
            <i class="material-icons">navigate_before</i>
        </div>
    </div>
    <div class="slide-navigate-item swiper-button-next sw-btn" (click)="next()">
        <div class="content"> 
            <i class="material-icons">navigate_next</i>
        </div>
    </div>
</div>
